export default {
	MAX_ZOOM_LEVEL_ON_CLICK_ON_MAP: 8,
	profileOptions: ["Lead", "Growth", "Emerging"],
	NO_INFORMATION: "TBC",
	NOT_AVAILABLE: "N/A",
	GLOBAL_MARKET_ID: 1395,
	exitFormWithDataMsg: "You're about to leave a page which has unsaved changes. Are you sure?",
	PAGE_TYPES: {
		MARKET: "Market",
		COMPANY: "Company",
		PROJECT: "Project"
	},
	colorPalette: {
		Colocation: "#AA0061",
		"Self-build": "#6E4180",
		Development: "#E4002B",
		Resolve: "#00B140",
		NonOperational: "#768592",
		EarlyStageSchemes: "#F0142F"
	},
	PROGRESS_STATUS: {
		notStarted: "notStarted",
		inProgress: "inProgress",
		complete: "complete"
	},
	SANITIZED_HTML_ALLOWED_TAGS: ["div", "p", "span", "br", "a", "b", "strong", "u", "em", "s", "blockquote", "pre", "ol", "ul", "li", "h1", "h2", "h3", "h4", "h5", "h6"],
	SANITIZED_HTML_ALLOWED_CLASSES: {
		p: ["ql-align-center", "ql-align-right", "ql-align-justify", "ql-direction-rtl", "ql-indent-1", "ql-indent-2", "ql-indent-3", "ql-indent-4", "ql-indent-5", "ql-indent-6", "ql-indent-7", "ql-indent-8"],
		pre: ["ql-syntax", "ql-align-center", "ql-align-right", "ql-align-justify", "ql-direction-rtl", "ql-indent-1", "ql-indent-2", "ql-indent-3", "ql-indent-4", "ql-indent-5", "ql-indent-6", "ql-indent-7", "ql-indent-8"],
		span: ["ql-size-small", "ql-size-large", "ql-size-huge"],
		li: ["ql-align-center", "ql-align-right", "ql-align-justify", "ql-direction-rtl", "ql-indent-1", "ql-indent-2", "ql-indent-3", "ql-indent-4", "ql-indent-5", "ql-indent-6", "ql-indent-7", "ql-indent-8"]
	},
	DCBYTE_LOGO_BASE64: "data:image/png;base64,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",
	CAPTCHA_ENABLED: process.env.REACT_APP_DOMAIN === "test123",
	NEW_ZEALAND_MARKET_ID: 871,
	NEW_ZEALAND_MARKETS_BOUNDARIES: [
		[
			[
				163.012862704,
				-51.350040687
			],
			[
				163.012862704,
				-33.546912519
			],
			[
				181.099877319,
				-33.546912519
			],
			[
				181.099877319,
				-51.350040687
			],
			[
				163.012862704,
				-51.350040687
			]
		]
	],
	PROVISIONAL_DATA: {
		LABEL: "Provisional Data*",
		POPUP_TITLE: "Provisional data",
		POPUP_CONTENT: "Data is not final after this point in time",
		LEGEND_STRING: "provisional",
		WIP_LABEL: "WIP*",
		WIP_POPUP_TITLE: "Work in progress",
		WIP_LEGEND_STRING: "WIP"
	},
	MAPBOX_API_KEY: process.env.REACT_APP_MAPBOX_API_KEY,
	DEFAULT_CURRENCY_CODE: "USD",
	CYPRESS_REACT_APP_DOMAIN: "cypress",
	QA_REACT_APP_DOMAIN: "qa",
	STAGING_REACT_APP_DOMAIN: "staging",
	PROD_REACT_APP_DOMAIN: "dcbyte",
	DEV_NODE_ENV: "development",
	PROD_NODE_ENV: "production",
	MEASUREMENT_SYSTEMS: {
		METRIC: "Metric",
		IMPERIAL: "Imperial"
	},
	MEASUREMENT_SYSTEM_COEFFICIENTS: {
		METER_TO_FEET: 3937 / 1200,
		SQ_METER_TO_SQ_FOOT: (3937 / 1200) ** 2,
		KILOMETER_TO_MILE: 0.62137119,
		HECTARES_TO_ACRES: 2.47105381467165,
		HECTARE_TO_SQM: 10000,
		ACRE_TO_SQFT: 43560
	},
	DCBYTE_NAME: "DC Byte",
	DEFAULT_PAGE_TITLE: "DC Byte | Everything About Data Centres",
	DEFAULT_PAGE_DESCRIPTION: "Welcome to DC Byte, an independent platform with a global outlook. Our goal is to bring transparency and clarity to the data centre sector, to make it easier for you to find the right location, to provide you with up-to-the-minute market analytics, and all in one place.",
	NOTIFICATION_TYPES: {
		MODAL: "Modal",
		BANNER: "Banner"
	},
	DCBYTE_FOOTER_VAT_TEXT: "Registered in England & Wales. Registered No. 10922025. VAT Registered No. GB 440 677 97.",
	COMPANY_IDS: {
		DCBYTE: 168,
		MOTIONSOFTWARE: 488
	}
};
